export const SECTION_DISPLAY_LIMIT = 7;
